import React from "react";
import { AuthHeaderActions } from "../components/ui/auth-header-actions";

export interface AuthLayoutProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  primaryGradientClassName?: string;
  secondaryGradientClassName?: string;
  iconContainerClassName?: string;
  currentLanguage?: string;
  onLanguageToggle?: () => void;
}

export function AuthLayout({
  children,
  icon,
  title,
  subtitle,
  primaryGradientClassName = "bg-primary/20",
  secondaryGradientClassName = "bg-secondary/20",
  iconContainerClassName = "bg-primary shadow-primary/30 text-white",
  currentLanguage = "en",
  onLanguageToggle = () => {},
}: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-surface-50 dark:bg-[#0D0E10] flex items-center justify-center p-4 relative overflow-hidden transition-colors duration-300">
      <AuthHeaderActions currentLanguage={currentLanguage} onLanguageToggle={onLanguageToggle} />

      {/* Background abstract shapes */}
      <div
        className={`absolute top-[-10%] left-[-10%] w-[40vw] h-[40vw] rounded-full blur-[150px] pointer-events-none ${primaryGradientClassName}`}
      />
      <div
        className={`absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] rounded-full blur-[150px] pointer-events-none ${secondaryGradientClassName}`}
      />

      <div className="w-full max-w-xl animate-fade-in relative z-10">
        {/* Logo */}
        <div className="mb-8 text-center flex flex-col items-center">
          <div
            className={`h-16 w-16 rounded-2xl flex items-center justify-center shadow-lg mb-4 ${iconContainerClassName}`}
          >
            {icon}
          </div>
          <span className="text-h2 font-bold text-surface-900 dark:text-white tracking-tight">
            {title}
          </span>
          <p className="text-caption text-surface-500 dark:text-[#C3C9B4] mt-1 uppercase tracking-widest font-bold">
            {subtitle}
          </p>
        </div>

        {/* Card */}
        <div className="min-h-[500px] bg-white/70 dark:bg-[#1A1C1E]/90 dark:text-white backdrop-blur-xl border border-white/40 dark:border-[#434939] shadow-[0_8px_32px_rgba(0,0,0,0.08)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.5)] rounded-3xl p-8">
          {children}
        </div>
      </div>
    </div>
  );
}
